"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ColorPicker_1 = require("./components/ColorPicker");
exports.ColorPicker = ColorPicker_1.default;
exports.textColors = ColorPicker_1.textColors;
exports.blackColors = ColorPicker_1.blackColors;
var FontNamePicker_1 = require("./components/FontNamePicker");
exports.FontNamePicker = FontNamePicker_1.default;
var FontSizePicker_1 = require("./components/FontSizePicker");
exports.FontSizePicker = FontSizePicker_1.default;
var colorStrings_1 = require("./strings/colorStrings");
exports.colorStrings = colorStrings_1.colorStrings;
//# sourceMappingURL=index.js.map